<template>
    <!--Desktop view-->
    <v-card v-if="!$vuetify.breakpoint.smAndDown" elevation="0">
        <v-toolbar flat>
            <v-row no-gutters>
                <v-col class="" cols="isPrice() ? '7' : '5'">
                    <h2 class="pink--text display-1">{{ item_name }}</h2>
                </v-col>
                <v-col :cols="isPrice() ? '5' : '7'">
                    <div class="d-flex mt-1">
                        <v-text-field
                            v-model="upfrontHistoryForm.upfront"
                            class="pt-1 mx-2"
                            dense
                            v-if="!isPrice()"
                            clearable
                            label="Importe"
                            type="number"
                            :rules="[rules.required, rules.gtzero]"
                        >
                        </v-text-field>
                        <v-text-field
                            v-model="priceHistoryForm.price"
                            class="pt-1 mx-2"
                            dense
                            v-else
                            clearable
                            label="Precio"
                            type="number"
                            :rules="[rules.required, rules.gtzero]"
                        >
                        </v-text-field>
                        <v-select
                            clearable
                            v-model="upfrontHistoryForm.tipo"
                            :items="typeChoices"
                            class="pt-1 mx-2"
                            v-if="!isPrice()"
                            label="Tipo"
                            dense
                        ></v-select>
                        <v-select
                            clearable
                            multiple
                            v-model="upfrontHistoryForm.familia_objetivo"
                            :items="tipoObjetivo"
                            item-text="nombre"
                            return-object
                            class="pt-1 mx-2"
                            v-if="!isPrice()"
                            label="Objetivo"
                            dense
                        >
                        </v-select>
                        <v-btn
                            class="ml-2"
                            v-if="isPrice()"
                            depressed
                            :disabled="disabledSavePrice()"
                            color="success"
                            @click="submit()"
                        >
                            <v-icon left> mdi-content-save </v-icon>
                            {{ formType }}
                        </v-btn>
                        <v-btn
                            v-else
                            class="ml-2"
                            depressed
                            :disabled="disabledSaveUpfront()"
                            color="success"
                            @click="submit()"
                        >
                            <v-icon left> mdi-content-save </v-icon>
                            {{ formType }}
                        </v-btn>
                        <div class="d-flex" @click="reset()">
                            <v-icon
                                left
                                class="d-flex justify-center ml-2 mb-4"
                            >
                                mdi-backspace-outline
                            </v-icon>
                            <h2 class="overline grey--text">Limpiar</h2>
                        </div>
                    </div>
                    <v-progress-linear
                        v-if="animate"
                        color="primary"
                        indeterminate
                        rounded
                        class="mt-n0 mx-2"
                        height="3"
                    ></v-progress-linear>
                </v-col>
            </v-row>
        </v-toolbar>
        <div class="pa-6 mt-3" v-if="items.length">
            <div class="mx-16" v-for="(item, index) in items" :key="index">
                <v-row>
                    <v-col cols="4">
                        <h2 class="font-weight-light">
                            {{
                                isPrice()
                                    ? 'Precio: ' + item.price
                                    : 'Upfront: ' + item.upfront
                            }}
                            €
                        </h2>
                    </v-col>
                    <v-col v-if="!isPrice()" cols="3">
                        <h2 class="font-weight-light">
                            {{ !isPrice() ? 'Tipo: ' + item.tipo : '' }}
                        </h2>
                    </v-col>
                    <v-col cols="isPrice() ? '6' : '3'" class="d-flex">
                        <h2
                            class="font-weight-light"
                            :style="isPrice() ? 'width: 20%;' : 'width: 35%;'"
                        >
                            {{ item.is_active ? 'Activo' : 'Inactivo' }}
                        </h2>
                        <v-icon
                            size="35"
                            right
                            :color="item.is_active ? 'green' : 'red'"
                            @click="switchActive(item)"
                        >
                            mdi-circle
                        </v-icon>
                    </v-col>
                    <v-col class="d-flex justify-end" cols="1">
                        <v-icon
                            size="40"
                            color="orange"
                            @click="openEditDialog(item)"
                        >
                            mdi-pen
                        </v-icon>
                    </v-col>
                    <v-col class="d-flex justify-end" cols="1">
                        <v-icon
                            size="40"
                            color="red"
                            @click="openDeleteDialog(item)"
                        >
                            mdi-delete
                        </v-icon>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-4">
                    <v-col cols="4">
                        <h4 class="font-weight-light grey--text">
                            Creado: {{ formatDate(item.created_on) }}
                        </h4>
                    </v-col>
                    <v-col cols="4">
                        <h4 class="font-weight-light grey--text">
                            Actualizado: {{ formatDate(item.updated_on) }}
                        </h4>
                    </v-col>
                </v-row>
            </div>
        </div>
        <div v-else>
            <h1
                style="font-size: 3em; background-color: rgb(239, 239, 239)"
                class="
                    font-weight-regular
                    py-4
                    d-flex
                    justify-center
                    grey--text
                "
            >
                Sin Entradas
            </h1>
        </div>
        <DeleteDialog />
    </v-card>

    <!--Mobile view-->

    <v-card v-else class="scroll" elevation="0">
        <v-row no-gutters>
            <v-col class="mt-2 pa-2" cols="isPrice() ? '12' : '12' ">
                <h2 class="pink--text display">{{ item_name }}</h2>
            </v-col>
            <v-col :cols="isPrice() ? '12' : '12'">
                <div class="mt-1">
                    <v-text-field
                        v-model="upfrontHistoryForm.upfront"
                        class="pt-1 mx-2"
                        dense
                        v-if="!isPrice()"
                        clearable
                        label="Importe"
                        type="number"
                        :rules="[rules.required, rules.gtzero]"
                    >
                    </v-text-field>
                    <v-text-field
                        v-model="priceHistoryForm.price"
                        class="pt-1 mx-2"
                        dense
                        v-else
                        clearable
                        label="Precio"
                        type="number"
                        :rules="[rules.required, rules.gtzero]"
                    >
                    </v-text-field>
                    <v-select
                        clearable
                        v-model="upfrontHistoryForm.tipo"
                        :items="typeChoices"
                        class="pt-1 mx-2"
                        v-if="!isPrice()"
                        label="Tipo"
                        dense
                    ></v-select>
                    <v-select
                        clearable
                        multiple
                        v-model="upfrontHistoryForm.familia_objetivo"
                        :items="tipoObjetivo"
                        item-text="nombre"
                        return-object
                        class="pt-1 mx-2"
                        v-if="!isPrice()"
                        label="Objetivo"
                        dense
                    >
                    </v-select>
                    <div class="d-flex justify-center">
                        <v-btn
                            class="ml-2"
                            v-if="isPrice()"
                            depressed
                            :disabled="disabledSavePrice()"
                            color="success"
                            @click="submit()"
                        >
                            <v-icon left> mdi-content-save </v-icon>
                            {{ formType }}
                        </v-btn>

                        <v-btn
                            v-if="!isPrice()"
                            class="ml-2"
                            depressed
                            :disabled="disabledSaveUpfront()"
                            color="success"
                            @click="submit()"
                        >
                            <v-icon left> mdi-content-save </v-icon>
                            {{ formType }}
                        </v-btn>
                        <div class="d-flex align-center" @click="reset()">
                            <v-icon left class="d-flex justify-center ml-2">
                                mdi-backspace-outline
                            </v-icon>
                            <h2 class="overline grey--text">Limpiar</h2>
                        </div>
                    </div>
                </div>
            </v-col>
        </v-row>
        <div class="pa-2" v-if="items.length">
            <div class="mx-10" v-for="(item, index) in items" :key="index">
                <v-row>
                    <v-col cols="12">
                        <h2 class="font-weight-light">
                            {{
                                isPrice()
                                    ? 'Precio: ' + item.price
                                    : 'Upfront: ' + item.upfront
                            }}
                            €
                        </h2>
                    </v-col>
                    <v-col v-if="!isPrice()" cols="12">
                        <h2 class="font-weight-light">
                            {{ !isPrice() ? 'Tipo: ' + item.tipo : '' }}
                        </h2>
                    </v-col>
                    <v-col cols="isPrice() ? '6' : '6'" class="d-flex">
                        <h2
                            class="font-weight-light"
                            :style="isPrice() ? 'width: 20%;' : 'width: 35%;'"
                        >
                            {{ item.is_active ? 'Activo' : 'Inactivo' }}
                        </h2>
                        <v-icon
                            size="35"
                            right
                            :color="item.is_active ? 'green' : 'red'"
                            @click="switchActive(item)"
                        >
                            mdi-circle
                        </v-icon>
                    </v-col>
                    <v-col cols="12" class="d-flex">
                        <v-col cols="6">
                            <v-icon
                                size="40"
                                color="orange"
                                @click="openEditDialog(item)"
                            >
                                mdi-pen
                            </v-icon>
                        </v-col>
                        <v-col cols="6">
                            <v-icon
                                size="40"
                                color="red"
                                @click="openDeleteDialog(item)"
                            >
                                mdi-delete
                            </v-icon>
                        </v-col>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-4">
                    <v-col cols="12">
                        <h4 class="font-weight-light grey--text">
                            Creado: {{ formatDate(item.created_on) }}
                        </h4>
                    </v-col>
                    <v-col cols="12">
                        <h4 class="font-weight-light grey--text">
                            Actualizado: {{ formatDate(item.updated_on) }}
                        </h4>
                    </v-col>
                </v-row>
            </div>
        </div>
        <div v-else>
            <h1
                class="
                    font-weight-regular
                    py-4
                    d-flex
                    justify-center
                    grey--text
                "
            >
                Sin Entradas
            </h1>
        </div>
        <DeleteDialog />
    </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { clone } from '@/util/libUtil.js';
import DeleteDialog from '@/components/DeleteDialog/DeleteDialog.vue';

export default {
    name: 'PricesUpfrontList',
    data: () => ({
        items: [],
        item_name: '',
        animate: false,
        editingId: null,
        formType: 'CREAR',

        rules: {
            required: (value) => !!value || 'Complete este campo',
            gtzero: (value) => value >= 0 || 'Solo mayor que 0',
        },
        typeChoices: [
            'SVA',
            'TARIFA',
            'MIGRACION',
            'PORTA_FIJO',
            'PORTA_MOVIL',
            'PREPAGO_ALTA',
            'PREPAGO_PORTA',
            'PORTA_ADIC',
            'RENUEVO',
            'CROSSELL',
        ],
    }),
    props: {
        father: '',
    },
    components: {
        DeleteDialog,
    },
    methods: {
        animation() {
            this.animate = true;
            setTimeout(() => {
                this.animate = false;
            }, 1500);
        },
        reset() {
            this.formType = 'CREAR';

            if (this.isPrice()) {
                this.priceHistoryForm.price = null;
                this.priceHistoryForm.is_active = null;
            } else {
                this.upfrontHistoryForm.tipo = null;
                this.upfrontHistoryForm.upfront = null;
                this.upfrontHistoryForm.is_active = null;
                this.upfrontHistoryForm.familia_objetivo = [];
            }
        },
        isPrice() {
            return this.father.includes('PRICE');
        },
        switchActive(item) {
            let copy = clone(item);
            copy.is_active = !item.is_active;
            this.openEditDialog(copy);
            this.submit();
            this.reset();
            this.formType = 'CREAR';
        },
        openEditDialog(item) {
            this.animation();
            this.formType = 'EDITAR';
            this.editingId = item.id;

            if (this.isPrice()) {
                this.priceHistoryForm.price = item.price;
                this.priceHistoryForm.is_active = item.is_active;
            } else {
                this.upfrontHistoryForm.tipo = item.tipo;
                this.upfrontHistoryForm.upfront = item.upfront;
                this.upfrontHistoryForm.is_active = item.is_active;
                this.upfrontHistoryForm.familia_objetivo =
                    item.familia_objetivo;
            }
        },
        submit() {
            if (
                this.father.includes('HISTORY_PRICE') &&
                this.formType == 'CREAR'
            )
                this.addPriceHistory();
            else if (
                this.father.includes('HISTORY_UPFRONT') &&
                this.formType == 'CREAR'
            )
                this.addUpfrontHistory();
            else if (
                this.father.includes('HISTORY_PRICE') &&
                this.formType == 'EDITAR'
            )
                this.editPriceHistory(this.editingId);
            else if (
                this.father.includes('HISTORY_UPFRONT') &&
                this.formType == 'EDITAR'
            )
                this.editUpfrontHistory(this.editingId);

            this.reset();
        },
        openDeleteDialog(item) {
            let type = null;
            if (this.father.includes('HISTORY_PRICE')) type = 'HISTORY_PRICE';
            if (this.father.includes('HISTORY_UPFRONT'))
                type = 'HISTORY_UPFRONT';

            let deleteObj = {
                toDeleteId: item.id,
                toDeleteType: type,
                isOpenDeleteDialog: true,
            };

            this.$store.commit('util/deleteDialog', clone(deleteObj));
        },
        formatDate(date) {
            let mondate = new Date(date);
            let options = {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                hour12: false,
                timeZone: 'Europe/Madrid',
            };
            return new Intl.DateTimeFormat('es-ES', options).format(mondate);
        },
        disabledSavePrice() {
            return (
                !this.priceHistoryForm.price ||
                Number(this.priceHistoryForm.price) < 0
            );
        },
        disabledSaveUpfront() {
            return (
                !this.upfrontHistoryForm.upfront ||
                this.upfrontHistoryForm.upfront < 0 ||
                !this.upfrontHistoryForm.tipo ||
                !this.upfrontHistoryForm.familia_objetivo
            );
        },
        order(array) {
            if (array) {
                array.sort(function (a, b) {
                    // Turn your strings into dates, and then subtract them
                    // to get a value that is either negative, positive, or zero.
                    return new Date(b.updated_on) - new Date(a.updated_on);
                });

                return array;
            } else return [];
        },
        updateItems() {
            if (this.father.includes('TARIFF')) {
                let found = this.tariffs.find(
                    (element) => element.id == this.item_id
                );
                this.item_name = found?.name;

                if (this.father.includes('HISTORY_UPFRONT'))
                    found
                        ? (this.items = this.order(found.upfront_history))
                        : (this.items = []);
                else
                    found
                        ? (this.items = this.order(found.price_history))
                        : (this.items = []);
            } else if (this.father.includes('ADITIONAL')) {
                let found = this.additionals.find(
                    (element) => element.id == this.item_id
                );
                this.item_name = found?.name;

                if (this.father.includes('HISTORY_UPFRONT'))
                    found
                        ? (this.items = this.order(found.upfront_history))
                        : (this.items = []);
                else
                    found
                        ? (this.items = this.order(found.price_history))
                        : (this.items = []);
            } else if (this.father.includes('SVA')) {
                let found = this.sva.find(
                    (element) => element.id == this.item_id
                );
                this.item_name = found?.name;

                if (this.father.includes('HISTORY_UPFRONT'))
                    found
                        ? (this.items = this.order(found.upfront_history))
                        : (this.items = []);
                else
                    found
                        ? (this.items = this.order(found.price_history))
                        : (this.items = []);
            } else if (this.father.includes('INSURANCE')) {
                let found = this.insurances.find(
                    (element) => element.id == this.item_id
                );
                this.item_name = found?.name;
                found
                    ? (this.items = this.order(found.upfront_history))
                    : (this.items = []);
            } else if (this.father.includes('ADMINISTRATION')) {
                let found = this.procedures.find(
                    (element) => element.id == this.item_id
                );
                this.item_name = found?.name;
                found
                    ? (this.items = this.order(found.upfront_history))
                    : (this.items = []);
            }
        },
        ...mapActions('ManagementBase', [
            'addPriceHistory',
            'addUpfrontHistory',
            'editPriceHistory',
            'editUpfrontHistory',
        ]),
    },
    computed: {
        upfrontHistoryForm: {
            get() {
                return this.$store.state.ManagementBase.baseForm
                    .upfrontHistoryForm;
            },
            set(val) {
                this.$store.commit('ManagementBase/upfrontHistoryForm', val);
            },
        },
        priceHistoryForm: {
            get() {
                return this.$store.state.ManagementBase.baseForm
                    .priceHistoryForm;
            },
            set(val) {
                this.$store.commit('ManagementBase/priceHistoryForm', val);
            },
        },
        ...mapState('ManagementBase', {
            tipoObjetivo: (state) => state.tipoObjetivo,
            item_id: (state) => state.baseForm.item_id,
        }),
        ...mapState('ManagementBase/tariffManagement', {
            tariffs: (state) => state.tariffManagement.tariffs,
        }),
        ...mapState('ManagementBase/additionalManagement', {
            additionals: (state) => state.additionalManagement.additionals,
        }),
        ...mapState('ManagementBase/SVAManagement', {
            sva: (state) => state.SVAManagement.svas,
        }),
        ...mapState('ManagementBase/insuranceManagement', {
            insurances: (state) => state.insurances,
        }),
        ...mapState('ManagementBase/procedureManagement', {
            procedures: (state) => state.procedures,
        }),
    },
    watch: {
        tariffs: {
            immediate: true,
            handler() {
                this.updateItems();
            },
        },
        additionals: {
            immediate: true,
            handler() {
                this.updateItems();
            },
        },
        sva: {
            immediate: true,
            handler() {
                this.updateItems();
            },
        },
        tariffs: {
            immediate: true,
            handler() {
                this.updateItems();
            },
        },
        insurances: {
            immediate: true,
            handler() {
                this.updateItems();
            },
        },
        procedures: {
            immediate: true,
            handler() {
                this.updateItems();
            },
        },
        item_id: {
            immediate: true,
            handler() {
                this.updateItems();
            },
        },
    },
    create() {
        this.updateItems();
    },
};
</script>

<style>
</style>